import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import  storeParamarsh  from './Redux/store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist';
import { CookiesProvider } from "react-cookie";


let persistedStoreParamarsh = persistStore(storeParamarsh);
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
    <Provider store={ storeParamarsh }>
      <PersistGate loading={null} persistor = {persistedStoreParamarsh}>
      <CookiesProvider>
        <App />
        </CookiesProvider>
      </PersistGate>
    </Provider>
  //  </React.StrictMode> 
)

reportWebVitals()

